export const opIdParamName = "opId";
export const actionParamName = "action";
export const trainingDashboardParamValue = "training-dashboard";
export const opEditParamValue = "edit";
export const opCloneParamValue = "clone";
export const stageParamName = "stage";
